import Vue from 'vue'
import Vuex from 'vuex'
import vuexLocal from '@/store/persistance'
import modules from '@/store/modules'
import { LABELS as LABELS_KEYS } from '@/enums'
import Api from '@/plugins/api'

Vue.use(Vuex)

const initialState = () => ({
  version: process.env.VUE_APP_VERSION,
  labels: {
    ...Object.keys(LABELS_KEYS).reduce(
      (acc, currentValue) => ({
        ...acc,
        [LABELS_KEYS[currentValue]]: {},
      }),
      {},
    ),
  },
  fetchedLabelTypes: [],
  skillId: null,
})

export const state = initialState()

export const mutations = {
  SET_LABELS(state, { type, value }) {
    if (!type) return

    state.labels = {
      ...state.labels,
      [type]: value || {},
    }
  },
  FETCHED_LABEL_TYPE(state, { type }) {
    if (!state.fetchedLabelTypes.includes(type))
      state.fetchedLabelTypes.push(type)
  },
  UPDATE_SKILL(state, payload) {
    state.skillId = payload
  },
}

export const actions = {
  // resets state of all the modules
  reset({ commit, rootGetters }, payload = Object.keys(modules)) {
    payload.forEach((moduleName) => {
      if (modules[moduleName].mutations.RESET) {
        commit(`${moduleName}/RESET`, {
          history: rootGetters['Widget/displayChatHistoryConversation'],
        })
      }
    })
    localStorage.removeItem('innso-chat-storage')
  },
  /**
   *  Retrieve fullframe labels from api
   */
  async getFulframeLabel({ state, commit }, type, forceRefresh = false) {
    if (!forceRefresh && Object.keys(state.labels[type]).length !== 0) {
      return
    }

    try {
      const { data } = await Api.chat.getFullframeLabels(type)
      commit('SET_LABELS', { type, value: data.data })
    } catch (e) {
      console.error(e)
    } finally {
      commit('FETCHED_LABEL_TYPE', { type })
    }
  },
  /**
   *  Retrieve teaser labels from api
   */
  async getTeaserLabel({ state, commit }, type, forceRefresh = false) {
    if (!forceRefresh && Object.keys(state.labels[type]).length !== 0) {
      return
    }

    const { data } = await Api.chat.getTeaserLabel(type)
    commit('SET_LABELS', { type, value: data.data })
  },
}

export const storeConfig = {
  strict: process.env.NODE_ENV !== 'production',
  state,
  mutations,
  modules,
  actions,
  plugins: [vuexLocal.plugin],
}

export default new Vuex.Store(storeConfig)
